module.exports = __webpack_public_path__ + "images/fa-signup-master-v2.webp";